import React from "react";
import { Box, Heading, Text, TextLink } from "@origin-digital/ods-core";
import type { ILabelQueryDto } from "../../contract/generated/bff/src/models";

interface NoResultsProps {
  spellingSuggestion: ILabelQueryDto | null;
}

const DidYouMeanLink = ({ label, query }: { label: string; query: string }) => (
  <TextLink
    href={`?term=${encodeURIComponent(query)}`}
    domProps={{ style: { fontWeight: 700 } }}
  >
    {label}
  </TextLink>
);

export const NoResults: React.FC<NoResultsProps> = ({ spellingSuggestion }) => (
  <Box
    data-id="no-results"
    paddingY="large"
    textAlign="center"
    display="flex"
    flexDirection="column"
    alignItems="center"
  >
    <Heading variant="h3">No results found</Heading>
    {spellingSuggestion && (
      <Box marginTop="large">
        <Text>
          Did you mean{" "}
          <DidYouMeanLink
            label={spellingSuggestion.label}
            query={spellingSuggestion.query}
          />
          ?
        </Text>
      </Box>
    )}

    <Box marginTop={spellingSuggestion ? "xxxsmall" : "large"}>
      <Text>Or try using a different search query</Text>
    </Box>
  </Box>
);
